import styled from '@emotion/styled';
import bg from 'public/term-card-bg.svg';

export const StyledLink = styled.div`
  background-image: url(${bg});
`;
